(function () {
    'use strict';

    angular
        .module('ib-ancillaries-directive-module')
        .directive('calculateHeightContainer', calculateHeightContainer);

    calculateHeightContainer.$inject = ['$window', '$timeout'];

    function calculateHeightContainer ($window, $timeout) {

        return {
            restrict: 'A',
            link: link
        };

        function link (scope, element) {

            function calculateHeightContainer () {

                $timeout(() => {
                    //Variables
                    const leyend = angular.element('.ib-map-seats__leyend');
                    const header = angular.element('.ib-map-seats__header');
                    const leyendHeight = leyend.outerHeight(true);
                    const headerHeight = header.outerHeight(true);
                    const totalHeight = leyendHeight + headerHeight;
                    //Apply height in seat map container (100% - leyend height - header height)
                    angular.element(element).css('height', 'calc(100% - ' + totalHeight + 'px)');
                });

            }

            calculateHeightContainer();

            scope.$on('changeHeightContainer', () => {
                calculateHeightContainer();
            });

            angular.element($window).on('resize', () => {
                calculateHeightContainer();
            });

        }
    }
})();